__turbopack_context__.v({
  "iconWrapper": "-omSfW_iconWrapper",
  "label": "-omSfW_label",
});
